import { z } from "zod";
import { uuid } from "../_common.js";

const platformEnum = z.enum(["telegram", "slack", "whatsapp"]);

export const VOICE_LANGUAGES = [
  { code: "ml", label: "Malayalam" },
  { code: "ta", label: "Tamil" },
  { code: "kn", label: "Kannada" },
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
] as const;

export type VoiceLanguageCode = (typeof VOICE_LANGUAGES)[number]["code"];

const voiceLanguageCode = z.enum(["ml", "ta", "kn", "en", "hi"]);

/** `botChannels.generateLinkToken` — create a one-time 6-digit link code. */
export const generateLinkTokenInput = z.object({
  platform: platformEnum,
});

export const generateLinkTokenOutput = z.object({
  token: z.string(),
  expiresAt: z.string(),
  instructions: z.string(),
  /**
   * WhatsApp "click to chat" deep link with the code pre-filled, pointing at
   * the configured bot number — null when the platform isn't WhatsApp or no
   * bot number is configured. The UI renders this as a QR code + open button.
   */
  deepLink: z.string().nullable(),
});

/** `botChannels.listConnections` — current bot sessions for this user. */
export const listConnectionsInput = z.object({});

export const listConnectionsOutput = z.array(
  z.object({
    id: uuid,
    platform: platformEnum,
    platformChatId: z.string(),
    preferredLanguage: voiceLanguageCode.nullable(),
    createdAt: z.string(),
    lastActiveAt: z.string(),
  }),
);

/** `botChannels.setLanguage` — update voice transcription language for a bot session. */
export const setLanguageInput = z.object({
  sessionId: uuid,
  preferredLanguage: voiceLanguageCode.nullable(),
});

export const setLanguageOutput = z.object({ ok: z.boolean() });

/** `botChannels.disconnect` — remove a bot session. */
export const disconnectInput = z.object({
  sessionId: uuid,
});

export const disconnectOutput = z.object({ ok: z.boolean() });
